var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#","target":"_blank"},on:{"click":function($event){_vm.$root.dispatchEvent('advertOffer');}}},[_c('img',{staticClass:"lightbox-body__offer",attrs:{"src":"http://via.placeholder.com/575x55?text=Advertiser+offer","alt":"Advertiser Offer"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ea8f14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLightboxDeal.vue
// module id = null
// module chunks = 